import * as favoriteList from '@wix/auto_sdk_dashboard-management_favorite-list';

export { favoriteList };
